var _rect, _rect2, _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 121,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 112,
  height: 112,
  x: 4,
  y: 4.5,
  stroke: "url(#no_chat_svg__a)",
  rx: 56
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 86.741,
  height: 86.741,
  x: 16.616,
  y: 17.114,
  stroke: "url(#no_chat_svg__b)",
  rx: 43.371
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_chat_svg__c)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 63.812,
  height: 63.812,
  x: 28.085,
  y: 28.583,
  fill: "#fff",
  rx: 31.906
}))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#no_chat_svg__d)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "no_chat_svg__e",
  width: 41,
  height: 40,
  x: 39,
  y: 40,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.5 40h40v40h-40z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  mask: "url(#no_chat_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFCAA1",
  strokeWidth: 2,
  d: "M44.438 78.828a3.767 3.767 0 0 0 3.765-3.766 3.77 3.77 0 0 0-3.766-3.765 3.77 3.77 0 0 0-3.765 3.766 3.767 3.767 0 0 0 3.766 3.765M47.1 72.4l4.414-4.413M44.439 41.172a3.77 3.77 0 0 1 3.765 3.766 3.767 3.767 0 0 1-3.766 3.765 3.767 3.767 0 0 1-3.765-3.766 3.77 3.77 0 0 1 3.765-3.765M47.1 47.6l4.415 4.414M74.563 41.172a3.77 3.77 0 0 0-3.766 3.766 3.767 3.767 0 0 0 3.766 3.765 3.767 3.767 0 0 0 3.765-3.766 3.77 3.77 0 0 0-3.766-3.765M71.9 47.6l-4.414 4.414M74.563 78.828a3.767 3.767 0 0 1-3.766-3.766 3.77 3.77 0 0 1 3.766-3.765 3.77 3.77 0 0 1 3.765 3.765 3.767 3.767 0 0 1-3.766 3.766M71.9 72.4l-4.414-4.413"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeWidth: 2.5,
  d: "M59.499 53.724a3.77 3.77 0 0 1 3.766 3.766 3.767 3.767 0 0 1-3.766 3.765 3.767 3.767 0 0 1-3.766-3.766 3.77 3.77 0 0 1 3.766-3.765"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeWidth: 2.5,
  d: "M59.5 48.703c6.235 0 11.297 5.063 11.297 11.297S65.735 71.297 59.5 71.297 48.203 66.235 48.203 60c0-6.234 5.062-11.297 11.297-11.297"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6E3037",
  strokeWidth: 2.5,
  d: "M53.224 69.392v-1.86a6.28 6.28 0 0 1 6.276-6.277 6.28 6.28 0 0 1 6.276 6.276v1.861a11.24 11.24 0 0 1-6.276 1.905 11.24 11.24 0 0 1-6.276-1.905"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_chat_svg__a",
  x1: 60,
  x2: 60,
  y1: 4,
  y2: 117,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FC8018"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#FAFAFA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_chat_svg__b",
  x1: 59.987,
  x2: 59.987,
  y1: 16.614,
  y2: 104.355,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FC8018"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#FAFAFA"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "no_chat_svg__d"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M39.5 40h40v40h-40z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "no_chat_svg__c",
  width: 119.812,
  height: 119.812,
  x: 0.085,
  y: 0.583,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  operator: "dilate",
  radius: 4,
  result: "effect1_dropShadow_655_31491"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 1 0 0 0 0 0.94902 0 0 0 0 0.913725 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_655_31491"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_655_31491",
  result: "shape"
})))));
export default SvgNoChat;